import { render } from "./SuccessPageForJob.vue?vue&type=template&id=5dd40b55&scoped=true"
import script from "./SuccessPageForJob.vue?vue&type=script&lang=js"
export * from "./SuccessPageForJob.vue?vue&type=script&lang=js"

import "./SuccessPageForJob.vue?vue&type=style&index=0&id=5dd40b55&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd40b55"]])

export default __exports__